import { Button } from "@/shared/components/ui/button";
import { usePwaUpdate } from "./UpdateContext";

/** The same explicit controls are available on About and on the compatibility screen. */
export function UpdateControls() {
  const update = usePwaUpdate();
  const messages = {
    idle: "برای بررسی نسخه جدید، دکمه زیر را بزنید.",
    checking: "در حال بررسی به‌روزرسانی…",
    downloading:
      "نسخه جدید در حال دریافت است؛ پس از آماده شدن می‌توانید برنامه را به‌روز کنید.",
    ready: "نسخه جدید آماده نصب است.",
    current: "نسخه برنامه شما به‌روز است.",
    offline: "اتصال اینترنت برقرار نیست. پس از اتصال دوباره تلاش کنید.",
    failed: "بررسی نسخه جدید انجام نشد. دوباره تلاش کنید.",
    unsupported:
      "به‌روزرسانی خودکار در این مرورگر یا اتصال در دسترس نیست. برنامه را از نشانی امن آن باز کنید.",
  };
  return (
    <div className="space-y-3">
      <p role="status" className="text-sm leading-7">
        {messages[update.status]}
      </p>
      {update.inFlight > 0 && (
        <p className="text-xs">
          درخواست در حال انجام است؛ تا پایان آن منتظر بمانید.
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outlineBrand"
          disabled={update.status === "checking" || update.isUpdating}
          onClick={() => void update.checkForUpdate()}
        >
          بررسی به‌روزرسانی
        </Button>
        {update.needRefresh && (
          <Button
            disabled={update.isUpdating || update.inFlight > 0}
            onClick={() => void update.updateApp()}
          >
            {update.isUpdating
              ? "در حال به‌روزرسانی…"
              : "به‌روزرسانی و بارگذاری مجدد"}
          </Button>
        )}
      </div>
    </div>
  );
}
